// extracted by mini-css-extract-plugin
export default {"footerContainer":"style_footerContainer__mlHPz"};